import PropTypes from 'prop-types';
import { BodyCopy } from '../ui/BodyCopy/BodyCopy';
import { ShippingDetailsStyles } from './ShippingDetails.style';

export const ShippingDetails = ({ availability, labels, layout }) => {
  const { primeShipping, pickUpFromStoreShipping, homeDeliveryShipping, expressShipping } = availability;
  return (
    <ul className="shipping-details">
      {primeShipping && (
        <li>
          <i className={`icon boomIcon icon-${layout}`}>
            <span className="sr-only">{labels.POD_BOOM_SHIPPING_LABEL}</span>
          </i>
        </li>
      )}
      {expressShipping && (
        <li className="shipping-wrapper">
          <div className="shipping-box">
            <span className="express-icon" />
            <BodyCopy size="copy4">
              {(cl) => <span dangerouslySetInnerHTML={{ __html: expressShipping }} className={`${cl}`} />}
            </BodyCopy>
          </div>
        </li>
      )}
      {homeDeliveryShipping && (
        <li className="shipping-wrapper">
          <div className="shipping-box">
            <span className="scheduled-icon" />
            <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{homeDeliveryShipping}</span>}</BodyCopy>
          </div>
        </li>
      )}
      {pickUpFromStoreShipping && (
        <li className="shipping-wrapper">
          <div className="shipping-box">
            <span className="store-icon" />
            <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{pickUpFromStoreShipping}</span>}</BodyCopy>
          </div>
        </li>
      )}
      <style jsx>{ShippingDetailsStyles}</style>
    </ul>
  );
};

ShippingDetails.defaultProps = {
  layout: '4_GRID',
};

ShippingDetails.propTypes = {
  availability: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  layout: PropTypes.string,
};
